import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Level } from 'rbx';
import styled from 'styled-components';

import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';

import { Heading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({ location }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Heading>Add / Edit Place</Heading>
      </Level.Item>
      <Level.Item align="right">
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/places'
                  ? 'create_place'
                  : 'create_place'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Link to="/add-place" className="button is-primary">
                  <span className="has-text-weight-semibold">Add a Place</span>
                </Link>
              )}
            />
          )}
        </ACLSConsumer>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default withRouter(Header);
